import { NavLink } from 'react-router-dom';
import { categoryLabel } from '../../data/categories';
import { getVisibleArticles } from '../../lib/content';
import { articlePath, profileHomePath } from '../../lib/routes';
import { PROFILE_LABEL, type Profile } from '../../types/profile';

export function Sidebar({ profile }: { profile: Profile }) {
  const articles = getVisibleArticles(profile);
  const grouped = articles.reduce<Record<string, typeof articles>>((acc, article) => {
    (acc[article.meta.category] ??= []).push(article);
    return acc;
  }, {});

  return (
    <aside className="help-sidebar" aria-label={`Ajuda para ${PROFILE_LABEL[profile]}`}>
      <NavLink className="sidebar-home" to={profileHomePath(profile)}>Visão geral</NavLink>
      <NavLink className="sidebar-home" to="/faq">Perguntas frequentes</NavLink>
      {Object.entries(grouped).map(([category, items]) => (
        <section className="sidebar-section" key={category}>
          <h2>{categoryLabel(category)}</h2>
          <ul>
            {items.map((article) => (
              <li key={article.meta.id}>
                <NavLink
                  to={articlePath(profile, article.meta.category, article.meta.slug)}
                  className={({ isActive }) => (isActive ? 'active' : undefined)}
                >
                  {article.meta.title}
                </NavLink>
              </li>
            ))}
          </ul>
        </section>
      ))}
    </aside>
  );
}
